var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldCoins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.003 512.003",
    style: {
      enableBackground: "new 0 0 512.003 512.003"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAD00"
    },
    d: "M249.062,0L249.062,0l-20.899,93.978l20.899,93.978l0,0c51.902,0,93.978-42.075,93.978-93.978 C343.039,42.075,300.965,0,249.062,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE2A"
    },
    d: "M155.084,93.978c0,51.902,42.075,93.978,93.978,93.978V0C197.159,0,155.084,42.075,155.084,93.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE2A"
    },
    d: "M249.062,37.991L249.062,37.991l-20.9,55.987l20.899,55.987l0,0 c30.872,0,55.987-25.116,55.987-55.987C305.049,63.108,279.934,37.991,249.062,37.991z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDEB95"
    },
    d: "M193.076,93.978c0,30.87,25.115,55.986,55.987,55.987V37.991 C218.191,37.991,193.076,63.108,193.076,93.978z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E68900"
    },
    points: "479.855,512 479.855,456.754 378.98,435.854 399.88,512 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFAD00"
    },
    points: "319.904,512 399.88,512 399.88,435.854 319.904,456.754 299.004,484.377 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E68900"
    },
    points: "319.904,456.753 219.029,435.854 239.928,512 319.904,512 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFAD00"
    },
    points: "159.952,456.753 139.053,484.377 159.952,512 239.928,512 239.928,435.854 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E68900"
    },
    points: "159.952,456.753 59.078,435.854 79.977,512 159.952,512 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.002,
    y: 456.756,
    style: {
      fill: "#FFAD00"
    },
    width: 79.976,
    height: 55.247
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE2A"
    },
    points: "512.002,456.754 512.002,401.507 479.855,401.507 411.127,380.608 432.026,456.754 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDEB95"
    },
    points: "352.051,456.754 432.026,456.754 432.026,380.608 352.051,401.507 331.152,426.323 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE2A"
    },
    points: "352.051,401.507 251.176,380.608 272.075,456.754 352.051,456.754 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDEB95"
    },
    points: "192.1,401.507 171.201,426.323 192.1,456.754 272.075,456.754 272.075,380.608 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE2A"
    },
    points: "192.1,401.507 91.224,380.608 112.124,456.754 192.1,456.754 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDEB95"
    },
    points: "32.149,401.507 32.149,456.754 112.124,456.754 112.124,380.608 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E68900"
    },
    points: "479.855,401.507 479.855,346.26 378.98,325.361 399.88,401.507 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFAD00"
    },
    points: "319.904,401.507 399.88,401.507 399.88,325.361 319.904,346.26 299.004,373.884 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E68900"
    },
    points: "319.904,401.507 319.904,346.26 219.029,325.361 239.928,401.507 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFAD00"
    },
    points: "159.952,401.507 239.928,401.507 239.928,325.361 159.952,346.26 139.053,373.884 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E68900"
    },
    points: "159.952,401.507 159.952,346.26 59.078,325.361 79.977,401.507 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.002,
    y: 346.258,
    style: {
      fill: "#FFAD00"
    },
    width: 79.976,
    height: 55.247
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE2A"
    },
    points: "512.002,291.015 432.026,291.015 411.127,318.637 432.026,346.26 512.002,346.26 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDEB95"
    },
    points: "352.051,291.015 331.152,318.637 352.051,346.26 432.026,346.26 432.026,291.015 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE2A"
    },
    points: "352.051,346.26 352.051,291.015 319.904,291.015 251.176,270.114 272.075,346.26 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDEB95"
    },
    points: "192.1,346.26 272.075,346.26 272.075,270.114 192.1,291.015 171.201,315.83 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE2A"
    },
    points: "192.1,291.015 91.224,270.114 112.124,346.26 192.1,346.26 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDEB95"
    },
    points: "32.149,291.015 32.149,346.26 112.124,346.26 112.124,270.114 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E68900"
    },
    points: "319.903,235.768 219.029,214.869 239.928,291.015 319.903,291.015 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFAD00"
    },
    points: "159.952,235.768 139.053,263.391 159.952,291.015 239.928,291.015 239.928,214.869  192.1,235.768 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E68900"
    },
    points: "159.952,235.768 79.977,235.768 59.078,263.391 79.977,291.015 159.952,291.015 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.002,
    y: 235.771,
    style: {
      fill: "#FFAD00"
    },
    width: 79.976,
    height: 55.247
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE2A"
    },
    points: "352.051,180.521 272.075,180.521 251.176,208.145 272.075,235.768 352.051,235.768 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.096,
    y: 180.517,
    style: {
      fill: "#FDEB95"
    },
    width: 79.976,
    height: 55.247
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldCoins);
export default __webpack_public_path__ + "static/media/gold_coins.2d848ab6fdc4a9ca2e0ade4cef5ca540.svg";
export { ForwardRef as ReactComponent };